import { render } from "./SubScriptionForm.vue?vue&type=template&id=3bf045f0"
import script from "./SubScriptionForm.vue?vue&type=script&lang=js"
export * from "./SubScriptionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__